<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Ajouter Endroit</h2>
    </div>
  </div>
  <AjouterFormEndroit ref="ajouterEndroit"/>
  <div class="row">
    <div v-if="!isDataLoading" class="col">
      <Button @click="ajouter"> Sauvegarder </Button>
    </div>
    <div v-else class="col">      
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import AjouterFormEndroit from '../../../../components/pilotage/Fichiers/Endroit/AjouterFormEndroit.vue'
export default {

  components : {
      AjouterFormEndroit
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Endroit");
  },
  data() {
    return {
      isDataLoading : false
    }
  },
  methods: {
    ajouter() {
      this.isDataLoading = true;
      let endroit = this.$refs.ajouterEndroit.getEndroitLocal();
      this.$store.dispatch('pilotage/ajouterEndroitAction', {endroit: endroit})
      .then(() => {
        this.isDataLoading = false;
        this.$toast.add({
          severity:'success',
          summary: 'Ajout Endroit',
          detail:"L'ajout a été effectué",
          life: 6000
        });
      })
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
}
</script>
